import { baseApi } from "@/shared/api";
import type { BankAccount, BankStatement, BankStatementRaw, StatementParams } from "./types";

export const bankingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBankAccounts: builder.query<BankAccount[], void>({
      query: () => ({
        url: "/api/banking/accounts/",
        method: "GET",
        credentials: "include" as const,
      }),
      providesTags: [{ type: "BankAccounts" as const, id: "LIST" }],
    }),
    getBankStatements: builder.query<BankStatement, StatementParams>({
      query: ({ iban, date_from, date_to }) => ({
        url: "/api/banking/statements/",
        method: "GET",
        params: { iban, date_from, date_to },
        credentials: "include" as const,
      }),
      transformResponse(response: BankStatementRaw): BankStatement {
        const fallbackCurrency = response.balanceIn?.currency ?? "KZT";
        return {
          ...response,
          debitTotalSum: response.debitTotalSum ?? { amount: 0, currency: fallbackCurrency },
          creditTotalSum: response.creditTotalSum ?? { amount: 0, currency: fallbackCurrency },
          paginationInfo: response.paginationInfo ?? {
            pageNumber: 1,
            pageSize: 20,
            pageCount: 0,
            totalCount: 0,
          },
        };
      },
      providesTags: (_result, _error, { iban }) => [{ type: "BankAccounts" as const, id: iban }],
    }),
  }),
});

export const { useGetBankAccountsQuery, useGetBankStatementsQuery } = bankingApi;
